import { primaryColor } from '@/src/styles/colors';
import styles from './FullSizeLoader.module.scss';
import { Loader } from '@mantine/core';

export const FullSizeLoader = () => (
  <div className={styles.wrapper}>
    <div className={styles.loader}>
      <h3>Veuillez patienter</h3>
      <p>Pour plus de sécurité, nous vérifions la validité de vos accès</p>
      <Loader color={primaryColor} />
    </div>
  </div>
);
